export default class RunningLine{

    static init(){
        let lines = document.getElementsByClassName('running-line')
        for(let line of lines){
            new RunningLine(line).init()
        }
    }

    elem
    #wrapper
    #items
    #transform = 0
    #stepItems = 0
    #speed = 1;
    #count = 0;
    #multiply = 1;
    

    constructor(sliderElem){
        this.elem = sliderElem
    }

    init(){
        try{
            this.#wrapper = this.elem.querySelector('.running-line-wrapper')
            if (!this.#wrapper)
                throw new Error('RunningLine must have wrapper for correct work!')
            this.#items = this.#wrapper.getElementsByClassName('running-line-item')
            let firstRect = this.#items[0].getBoundingClientRect()
            let lastRect = this.#items[this.#items.length-1].getBoundingClientRect();
            let lastStyle = getComputedStyle(this.#items[this.#items.length-1])
            this.#stepItems = Math.abs(firstRect.left)+Math.abs(lastRect.left)+lastRect.width + Number(lastStyle.marginLeft.replace('px',''))
            if(this.elem.hasAttribute('data-speed'))
                this.#speed = Number(this.elem.getAttribute('data-speed'))
            this.run()
            return true
        }catch(err){
            console.error(err)
            return false
        }
    }

    run(){
        this.#transform+=this.#speed
        this.#wrapper.style.transform=`translateX(${this.#transform}px)`
        this.isVisibleItems()
        requestAnimationFrame(this.run.bind(this))
    } 

    isVisibleItems(){
        const rectElem = this.elem.getBoundingClientRect();
        
       
        for(let item of this.#items){
            let rect = item.getBoundingClientRect()
            if(rect.left > rectElem.width){
                if(this.#count%this.#items.length==0 && this.#count!=0){
                    this.#multiply+=1
                }
                this.#count++
                const transformItems = this.#multiply * this.#stepItems
                item.style.transform=`translateX(-${transformItems}px)`
            }
        }
    }
}